/* WizardFooterNav — Back / Next controls shared across every wizard
   step (Brand, slide N, Funder-ready check, Generate). Small enough that
   living outside PitchEditor.jsx doesn't hurt readability of the wiring.

   Kept in its own file so `WizardSlidePreviewAndNav.jsx` (which uses it
   as a sub-component) can be extracted cleanly too.
*/

import React from "react";
import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";

const TEAL = "#0A8B85";

export default function WizardFooterNav({
  onBack,
  onNext,
  nextLabel = "Next",
  backLabel = "Back",
  showBack = true,
}) {
  return (
    <div
      className="max-w-[1000px] mx-auto mt-10 flex items-center justify-between gap-4 pt-6 border-t"
      style={{ borderColor: "rgba(255,255,255,0.06)" }}
      data-testid="wizard-footer-nav"
    >
      {showBack && onBack ? (
        <button
          onClick={onBack}
          data-testid="wizard-back-btn"
          className="text-sm font-semibold px-4 py-2.5 rounded-md inline-flex items-center gap-1.5 hover:bg-white/5 transition-colors text-white/70"
        >
          <ArrowLeft size={14} /> {backLabel}
        </button>
      ) : (
        <span />
      )}
      <button
        onClick={onNext}
        data-testid="wizard-next-btn"
        className="text-sm font-bold px-5 py-2.5 rounded-md inline-flex items-center gap-1.5 transition-colors"
        style={{ backgroundColor: TEAL, color: "#fff" }}
      >
        {nextLabel} <ArrowRight size={14} weight="bold" />
      </button>
    </div>
  );
}
